import { trackEvent } from '@/helper/mixPanel';
import { getAuth } from '@/services/auth.service';

export const trackCommandEvents = (command, source, assetType, assetName, viewMetric = '', tenor = '', props = {}) => {
    if (assetName === '') return;
    const auth = getAuth();

    const eventData = {
        ...props,
        commandName: command,
        userId: auth?.id,
        source,
        assetType,
        assetName
    };

    if (command === 'GP') {
        eventData = { ...eventData, viewMetric, tenor };
    } else if (command === 'HP') {
        eventData = { ...eventData, tenor };
    }

    trackEvent(`${command} Command`, eventData);
};

export const eventCommands = ['SHARE', 'CN', 'HP', 'GP', 'TRADES', 'TOP', 'DES', 'YAS', 'HS', 'PLOT', 'INP', 'BASIS', 'BXT', 'SXT', 'CORP', 'SDR', 'ATLAS', 'REGRESS', 'THOR', 'TRACE', 'CURVE'];
